import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { operations } from './generated/gcss';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { GCSS_URLS } from '@/constants/api';
import { apiGcssFetcher } from '../fetcher';
import { sleep } from '@/utils/promise';
export type ProductListResponse = operations['products']['responses']['200']['content']['application/json'] | undefined;
export type Product = NonNullable<ProductListResponse>['data'][number];
type QueryParams = operations['products']['parameters']['query'];
export function useGcssProductList(params) {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = QUERY_KEYS.gcssProductList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = async t2 => {
      const {
        pageParam,
        signal
      } = t2;
      await sleep(400);
      if (!signal?.aborted) {
        const res = await apiGcssFetcher(GCSS_URLS.productList, {
          searchParams: {
            ...params,
            ...(pageParam || {})
          }
        });
        return res.json;
      }
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t1) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      getNextPageParam: _temp,
      getPreviousPageParam: _temp2,
      initialPageParam: t2,
      placeholderData: keepPreviousData,
      retryDelay: 1000
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useInfiniteQuery(t3);
}
function _temp2(page_0) {
  if (!page_0) {
    return;
  }
  const before = new URLSearchParams(new URL(`${process.env.NEXT_PUBLIC_GCSS_API_URL}${page_0?.pagingInfo.prevPage}`).searchParams).get("before");
  return before ? {
    before
  } : undefined;
}
function _temp(page) {
  if (!page) {
    return;
  }
  const after = new URLSearchParams(new URL(`${process.env.NEXT_PUBLIC_GCSS_API_URL}${page?.pagingInfo.nextPage}`).searchParams).get("after");
  return after ? {
    after
  } : undefined;
}